import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import ApiService from 'services/apiService';
import localStorageService from 'services/LocalStorageService';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import 'chartjs-adapter-date-fns';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
  section: {
    '&:not(:last-child)': {
      marginBottom: theme.typography.pxToRem(32),
    },
  },
  sectionHeading: {
    marginBottom: theme.typography.pxToRem(16),
  },
}));

const breadcrumbs = [
  // { label: <IntlMessages id={'sidebar.main'} />, link: '/' },
  // { label: <IntlMessages id={'pages.editTable'} />, isActive: true },
];
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, TimeScale);

const initialLogData = {
  store: { '': 0 },
  activity: { '': 0 },
  product: { '': 0 },
  pointcard: { '': 0 },
  coupon: { '': 0 },
  member: { '': 0 },
  cart: { '': 0 },
  category: { '': 0 },
  game: { '': 0 },
  gamePointcard: { '': 0 },
  call_edit: { '': 0 },
  call_files: { '': 0 },
  call_login: { '': 0 },
  call_createAndRun: { '': 0 },
  call_checkFlag: { '': 0 },
  call_analyze: { '': 0 },
  call_comments: { '': 0 },
  call_queryType: { '': 0 },
  call_replyComments: { '': 0 },
};
const initialLabelData = ['', '', '', '', '', ''];
const initialHashTable = { 1234567: '' };
const initialFilterDate = {
  start: `${new Date().getFullYear()}-${(new Date().getMonth() - 2).toString().padStart(2, 0)}-${new Date()
    .getDate()
    .toString()
    .padStart(2, 0)}`,
  end: `${new Date().getFullYear()}-${(new Date().getMonth() + 1).toString().padStart(2, 0)}-${new Date()
    .getDate()
    .toString()
    .padStart(2, 0)}`,
};
const initialCategoryCount = {
  product: 0,
  activity: 0,
  pointcard: 0,
  member: 0,
  cart: 0,
  store: 0,
  coupon: 0,
  category: 0,
  game: 0,
  gamePointcard: 0,
  call_edit: 0,
  call_files: 0,
  call_login: 0,
  call_createAndRun: 0,
  call_checkFlag: 0,
  call_analyze: 0,
  call_comments: 0,
  call_queryType: 0,
  call_replyComments: 0,
};

/**函式區 */
// 取得所有商家後台點擊次數 函式
const getAnalysisLog = () => {
  return new Promise((resolve, reject) => {
    const token = localStorageService.getToken();
    ApiService.log
      .listCmsAllStore(token)
      .then(response => {
        const result = {};
        const rawData = JSON.parse(JSON.stringify(response.data.logData));
        if(rawData.store) rawData.store = Object.entries(rawData.store);
        if(rawData.activity) rawData.activity = Object.entries(rawData.activity);
        if(rawData.product) rawData.product = Object.entries(rawData.product);
        if(rawData.pointcard) rawData.pointcard = Object.entries(rawData.pointcard);
        if(rawData.coupon) rawData.coupon = Object.entries(rawData.coupon);
        if(rawData.member) rawData.member = Object.entries(rawData.member);
        if(rawData.cart) rawData.cart = Object.entries(rawData.cart);
        if(rawData.category) rawData.category = Object.entries(rawData.category);
        if(rawData.game) rawData.game = Object.entries(rawData.game);
        if(rawData.gamePointcard) rawData.gamePointcard = Object.entries(rawData.gamePointcard);
        if(rawData.call_edit) rawData.call_edit = Object.entries(rawData.call_edit);
        if(rawData.call_files) rawData.call_files = Object.entries(rawData.call_files);
        if(rawData.call_login) rawData.call_login = Object.entries(rawData.call_login);
        if(rawData.call_createAndRun) rawData.call_createAndRun = Object.entries(rawData.call_createAndRun);
        if(rawData.call_checkFlag) rawData.call_checkFlag = Object.entries(rawData.call_checkFlag);
        if(rawData.call_analyze) rawData.call_analyze = Object.entries(rawData.call_analyze);
        if(rawData.call_comments) rawData.call_comments = Object.entries(rawData.call_comments);
        if(rawData.call_queryType) rawData.call_queryType = Object.entries(rawData.call_queryType);
        if(rawData.call_replyComments) rawData.call_replyComments = Object.entries(rawData.call_replyComments);
        delete rawData.labels;
        result.labels = response.data.logData.labels;
        result.logData = rawData;
        result.countTotal = response.data.countTotal;
        result.count = response.data.count;
        // console.log('result', result);
        resolve(result);
      })
      .catch(error => reject(error));
  });
};
/** hash 函式
 * x 軸labels(時間)轉為timestamp的hash table
 * @param {Array} labels
 * @returns
 */
const hashfn = labels => {
  let hashTable = {};
  labels.map(label => {
    hashTable[new Date(label).setHours(0, 0, 0, 0)] = label;
  });
  return hashTable;
};
// x軸label過濾(時間)
const labelFilter = (labels, startTime, endTime) =>
  new Promise((resolve, reject) => {
    // x 時間軸filter
    let filteredDateLabel = labels
      .map(label => new Date(label).setHours(0, 0, 0, 0))
      .filter(item => item >= startTime && item <= endTime);
    resolve(filteredDateLabel);
  });
// 資料隨著時間過濾
const dataFilter = (logData, startTime, endTime) =>
  new Promise((resolve, reject) => {
    // console.log('log data', logData)
    const result = { count: 0, data: {} };
    let countTotal = 0;
    for (let key in logData) {
      // console.log(key, logData[key])
      result.data[key] = logData[key].filter(singleDate => {
        const timestamp = new Date(singleDate[0]).setHours(0, 0, 0, 0);
        return timestamp >= startTime && timestamp <= endTime;
      });
      // 總次數計算
      let count = result.data[key].reduce((accumulator, currentValue, currentIndex, array) => {
        return accumulator + currentValue[1];
      }, 0);
      countTotal += count;
    }
    result.count = countTotal;
    // console.log('result',result)
    resolve(result);
  });

// chart.js 設定config
const options = {
  maintainAspectRatio: false,
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: true,
      text: '管理後臺點擊曲線圖',
    },
  },
  scales: {
    y: {
      beginAtZero: true,
    },
  },
};

export default function CmsAllStoreTable() {
  const classes = useStyles();
  const [labels, setLebels] = React.useState(initialLabelData);
  const [logdata, setLogData] = React.useState(initialLogData);
  const [countTotal, setCountTotal] = React.useState(0);
  const [filteredLabel, setFilteredLabel] = React.useState(initialLabelData);
  const [filteredLogdata, setFilteredLogData] = React.useState(initialLogData);
  const [filteredCountTotal, setFilteredCountTotal] = React.useState(0);
  const [hashTable, setHashTable] = React.useState(initialHashTable);
  const [categoryCount, setCategoryCount] = React.useState(initialCategoryCount);
  const [optionsState, setOptionsState] = React.useState(0);
  React.useEffect(() => {
    getAnalysisLog()
      .then(result => {
        setCountTotal(result.countTotal);
        setFilteredCountTotal(result.countTotal);
        setLebels(result.labels);
        setFilteredLabel(result.labels);
        setLogData(result.logData);
        setFilteredLogData(result.logData);
        setCategoryCount(result.count);
        const labelHashTable = hashfn(result.labels);
        setHashTable(labelHashTable);
      })
      .catch(error => {
        console.log(error);
        // 出現錯誤回復初始設定值
        setFilteredLabel(initialLabelData);
        setFilteredLogData(initialLogData);
        setFilteredCountTotal(0);
        setLebels(initialLabelData);
        setLogData(initialLogData);
        setFilterDate(initialFilterDate);
        setOptionsState(0);
      });
  }, []);

  const data = {
    labels: filteredLabel,
    datasets: [
      {
        label: '商家編輯',
        data: filteredLogdata.call_edit,
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
      },
      {
        label: '商家上傳',
        data: filteredLogdata.call_files,
        borderColor: 'rgba(255, 159, 64)',
        backgroundColor: 'rgba(255, 159, 64, 0.2)',
      },
      {
        label: '商家登入',
        data: filteredLogdata.call_login,
        borderColor: 'rgba(255, 205, 86)',
        backgroundColor: 'rgba(255, 205, 86, 0.2)',
      },
      {
        label: 'GBP建立執行',
        data: filteredLogdata.call_createAndRun,
        borderColor: 'rgba(75, 192, 192)',
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
      },
      {
        label: '狀態檢查',
        data: filteredLogdata.call_checkFlag,
        borderColor: 'rgba(54, 162, 235)',
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
      },
      {
        label: '評論總分析',
        data: filteredLogdata.call_analyze,
        borderColor: 'rgba(153, 102, 255)',
        backgroundColor: 'rgba(153, 102, 255, 0.2)',
      },
      {
        label: '評論查詢',
        data: filteredLogdata.call_comments,
        borderColor: 'rgba(201, 203, 207)',
        backgroundColor: 'rgba(201, 203, 207, 0.2)',
      },
      {
        label: '評論類別分析',
        data: filteredLogdata.call_queryType,
        borderColor: 'rgb(128, 155, 0)',
        backgroundColor: 'rgb(128, 155, 0, 0.2)',
      },
      {
        label: '生成回覆評論',
        data: filteredLogdata.call_replyComments,
        borderColor: 'rgb(128, 155, 0)',
        backgroundColor: 'rgb(128, 155, 0, 0.2)',
      },
      /* {
        label: '商家資訊',
        data: filteredLogdata.store,
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
      },
      {
        label: '活動資訊',
        data: filteredLogdata.activity,
        borderColor: 'rgba(255, 159, 64)',
        backgroundColor: 'rgba(255, 159, 64, 0.2)',
      },
      {
        label: '商品管理',
        data: filteredLogdata.product,
        borderColor: 'rgba(255, 205, 86)',
        backgroundColor: 'rgba(255, 205, 86, 0.2)',
      },
      {
        label: '集點卡管理',
        data: filteredLogdata.pointcard,
        borderColor: 'rgba(75, 192, 192)',
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
      },
      {
        label: '優惠管理',
        data: filteredLogdata.coupon,
        borderColor: 'rgba(54, 162, 235)',
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
      },
      {
        label: '會員管理',
        data: filteredLogdata.member,
        borderColor: 'rgba(153, 102, 255)',
        backgroundColor: 'rgba(153, 102, 255, 0.2)',
      },
      {
        label: '訂單紀錄',
        data: filteredLogdata.cart,
        borderColor: 'rgba(201, 203, 207)',
        backgroundColor: 'rgba(201, 203, 207, 0.2)',
      },
      {
        label: '商品分類管理',
        data: filteredLogdata.category,
        borderColor: 'rgb(128, 155, 0)',
        backgroundColor: 'rgb(128, 155, 0, 0.2)',
      },
      {
        label: 'AR遊戲管理',
        data: filteredLogdata.gamePointcard,
        borderColor: 'rgb(128, 155, 0)',
        backgroundColor: 'rgb(128, 155, 0, 0.2)',
      }, */
    ],
  };
  // 日期輸入
  const [filterDate, setFilterDate] = React.useState(initialFilterDate);
  const handleStartChange = event => {
    event.persist();
    setFilterDate(state => ({ ...state, start: event.target.value }));
  };
  const handleEndChange = event => {
    event.persist();
    setFilterDate(state => ({ ...state, end: event.target.value }));
  };

  // 過濾搜尋
  const handleClick = event => {
    event.preventDefault();
    const startTime = new Date(filterDate.start).setHours(0, 0, 0, 0);
    const endTime = new Date(filterDate.end).setHours(0, 0, 0, 0);
    labelFilter(labels, startTime, endTime).then(res => {
      const filteredDateLabel = res.map(item => hashTable[item]);
      setFilteredLabel(filteredDateLabel);
    });
    dataFilter(logdata, startTime, endTime).then(res => {
      // console.log('res from cms all data data filter', res)
      setFilteredCountTotal(res.count);
      setFilteredLogData(res.data);
    });
  };
  // 清除
  const handleClickReset = event => {
    event.preventDefault();
    setFilteredLabel(labels);
    setFilteredLogData(logdata);
    setFilterDate(initialFilterDate);
    setFilteredCountTotal(countTotal);
    setOptionsState(0);
  };
  // 類別總數 SELECT
  const handleCategoryChange = e => {
    setOptionsState(e.target.value);
  };
  return (
    <Box className={classes.section} style={{ height: '400px', paddingBottom: '150px' }}>
      <h3>後台操作-所有商家 共:{filteredCountTotal} </h3>
      <p>
        開始時間: {filterDate.start} 結束時間: {filterDate.end}
      </p>
      <input type="date" id="start" name="start" onChange={handleStartChange} value={filterDate.start} />
      <input type="date" id="end" name="end" onChange={handleEndChange} value={filterDate.end} />

      <Button variant="outlined" color="primary" style={{ marginLeft: '10px' }} onClick={handleClick}>
        過濾
      </Button>
      <Button variant="outlined" color="primary" style={{ marginLeft: '10px' }} onClick={handleClickReset}>
        清除
      </Button>
      {categoryCount !== undefined ? (
        <>
          <select value={optionsState} onChange={handleCategoryChange} style={{ marginLeft: '10px' }}>
            <option value={0}>請選擇類別查看總觸及次數</option>
            <option value={categoryCount.call_edit}>商家編輯</option>
            <option value={categoryCount.call_files}>商家上傳</option>
            <option value={categoryCount.call_login}>商家登入</option>
            <option value={categoryCount.call_createAndRun}>GBP建立執行</option>
            <option value={categoryCount.call_checkFlag}>狀態檢查</option>
            <option value={categoryCount.call_analyze}>評論總分析</option>
            <option value={categoryCount.call_comments}>評論查詢</option>
            <option value={categoryCount.call_queryType}>評論類別分析</option>
            <option value={categoryCount.call_replyComments}>生成回覆評論</option>
            {/* <option value={categoryCount.store}>商家資訊</option>
            <option value={categoryCount.activity}>活動資訊</option>
            <option value={categoryCount.product}>商品管理</option>
            <option value={categoryCount.pointcard}>集點卡管理</option>
            <option value={categoryCount.coupon}>優惠管理</option>
            <option value={categoryCount.member}>會員管理</option>
            <option value={categoryCount.cart}>訂單紀錄</option>
            <option value={categoryCount.category}>商品分類管理</option>
            <option value={categoryCount.gamePointcard}>AR遊戲管理</option> */}
          </select>
          <h4 style={{ display: 'inline-block', marginLeft: '10px' }}>共:{optionsState}</h4>
        </>
      ) : (
        ''
      )}
      <Line data={data} width={600} height={400} options={options} />
    </Box>
  );
}
